import {
    RESET_LOAN_CALCULATE_ACTION_STATE,
    RESET_LOAN_CALCULATE_STATE,
    CALCULATE_LOAN,
    CALCULATE_LOAN_SUCCESS,
    CALCULATE_LOAN_FAIL,
} from "./actionTypes";

export const calculateLoan = (data) => ({
    type: CALCULATE_LOAN,
    payload: data,
});

export const calculateLoanSuccess = data => ({
    type: CALCULATE_LOAN_SUCCESS,
    payload: data,
});

export const calculateLoanFail = error => ({
    type: CALCULATE_LOAN_FAIL,
    payload: error,
});

//reset
export const resetLoanCalculateActionState = () => {
    return {
        type: RESET_LOAN_CALCULATE_ACTION_STATE,
    }
}
export const resetLoanCalculateState = () => {
    return {
        type: RESET_LOAN_CALCULATE_STATE,
    }
}

